import { render } from "./ClientCorporate.vue?vue&type=template&id=4d01bfac"
import script from "./ClientCorporate.vue?vue&type=script&lang=js"
export * from "./ClientCorporate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__